<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <h3 class="float-left">Invoice List</h3>
                    <!-- Button to Go Back -->
                    <CButton
                        class="float-right hideOnPrint"
                        color="secondary"
                        @click="$router.go(-1)"
                        ><CIcon name="cilChevronLeft" />
                        Back
                    </CButton>
                </CCardHeader>

                <CCardBody>
                    <CRow>
                        <CCol sm="12" md="5">
                            <h4>Filters</h4>
                            <CRow>
                                <CCol md="12" class="mb-2">
                                    <span class="mr-2">All Invoices</span>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="openInvoicesOnly" v-model="openInvoicesOnly">
                                        <label class="custom-control-label" for="openInvoicesOnly">Open Invoices</label>
                                    </div>
                                </CCol>
                                <CCol md="6">
                                    <label>Invoice Date</label>
                                    <datepicker
                                        v-model="fromDate"
                                        :format="dateFormat"
                                        :clear-button="true"
                                        clear-button-icon=""
                                        placeholder="From Date"
                                    ></datepicker>
                                </CCol>
                                <CCol md="6" class="pt-2">
                                    <label></label>
                                    <datepicker
                                        v-model="toDate"
                                        :format="dateFormat"
                                        :clear-button="true"
                                        clear-button-icon=""
                                        placeholder="To Date"
                                    ></datepicker>
                                </CCol>
                                <CCol md="12">
                                    <CAlert
                                        color="warning m-2"
                                        v-if="limitReached"
                                    >
                                        Warning! Your filter has reached the
                                        limit of
                                        {{ limit }} orders. Please alter your
                                        filters to see other results.
                                    </CAlert>
                                </CCol>
                                <CCol md="12">
                                    <CButton
                                        class="filterBtn mt-2"
                                        type="submit"
                                        color="primary"
                                        @click="getInvoicesList(true)"
                                    >
                                        Filter
                                    </CButton>
                                    <CButton
                                        class="filterBtn mt-2 ml-1"
                                        color="primary"
                                        @click="resetFilters()"
                                    >
                                        Reset
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CCol>
                        <CCol sm="12" md="7" v-if="this.totals">
                            <CRow>
                                <CCol col="1"></CCol>
                                <CCol col="11"><h4>Account Overview</h4></CCol>
                            </CRow>
                            <CRow>
                                <CCol col="1"></CCol>
                                <CCol col="3"><p>Past Due</p></CCol>
                                <CCol col="3"
                                    ><p class="text-right">
                                        {{ this.totals.pastDueTotals | currency }}
                                    </p></CCol
                                >
                                <CCol col="3"
                                    ><CButton
                                        class="w-100"
                                        color="success"
                                        size="sm"
                                        @click="payInvoices(invoices.pastDueInvoices)"
                                        type="submit"
                                    >
                                        Pay - Past Due
                                    </CButton></CCol
                                >
                            </CRow>
                            <CRow>
                                <CCol col="1"></CCol>
                                <CCol col="3"><p>Due in 0 - 30 Days</p></CCol>
                                <CCol col="3"
                                    ><p class="text-right">
                                        {{ this.totals.thisMonthDueTotals | currency }}
                                    </p></CCol
                                >
                                <CCol col="3"
                                    ><CButton
                                        class="w-100"
                                        color="success"
                                        size="sm"
                                        @click="payInvoices(invoices.thisMonthInvoices)"
                                        type="submit"
                                    >
                                        Pay - 0 - 30 Days
                                    </CButton>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol col="1"></CCol>
                                <CCol col="3"><p>Due in 31 - 60 Days</p></CCol>
                                <CCol col="3"
                                    ><p class="text-right">
                                        {{ this.totals.nextMonthDueTotals | currency }}
                                    </p></CCol
                                >
                                <CCol col="3"
                                    ><CButton
                                        class="w-100"
                                        color="success"
                                        size="sm"
                                        @click="payInvoices(invoices.nextMonthInvoices)"
                                        type="submit"
                                    >
                                        Pay 31 - 60 Days
                                    </CButton>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol col="1"></CCol>
                                <CCol col="3"><p>Total AR Balance</p></CCol>
                                <CCol col="3"
                                    ><p class="text-right">
                                        {{ this.totals.totalAR | currency }}
                                    </p></CCol
                                >
                                <CCol col="3">
                                    <CButton
                                        class="w-100"
                                        color="success"
                                        size="sm"
                                        @click="payInvoices(invoices.allInvoices)"
                                        type="submit"
                                    >
                                        Pay - Total AR Balance
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CDataTable
                        hover
                        striped
                        clickable-rows
                        :sorter="{ external: false, resetable: true }"
                        :items="items"
                        :fields="fields"
                        :columnFilter="{ external: false, lazy: false }"
                        :items-per-page="pageLimit"
                        :itemsPerPageSelect="true"
                        :active-page="activePage"
                        @row-clicked="rowClicked"
                        @pagination-change="paginationChanged"
                    >
                        <template #over-table>
                            <CButton
                                color="success"
                                class="px-4 mb-1"
                                @click="payInvoices(selectedInvoices)"
                                type="submit"
                                :disabled="selectedInvoices.length == 0"
                                ><CIcon name="cil-credit-card" />
                                Pay Selected Invoices <span v-if="selectedInvoices.length > 0">({{ selectedInvoices.length }})</span>
                            </CButton>
                            <CButton class="float-right px-4 mb-1" color="primary">
                                <download-csv :data="items">
                                    <CIcon name="cil-save" />
                                    Download Data
                                </download-csv>
                            </CButton>
                        </template>
                        <template #invoiceDate="data">
                            <td class="text-center">
                                {{ data.item.invoiceDate }}
                            </td>
                        </template>
                        <template #invoiceStatus="data">
                            <td class="text-center">
                                <CBadge
                                    :color="getBadge(data.item.invoiceStatus)"
                                >
                                    {{ data.item.invoiceStatus }}
                                </CBadge>
                            </td>
                        </template>
                         <template #paymentId="data">
                            <td class="text-center" >
                                <a
                                    v-if="hasPaymentHistoryPermission"
                                    @click.stop="goToPayment(data.item)"
                                    href="javascript:void(0);"
                                >
                                    {{ data.item.paymentId }}
                                </a>
                                <span v-else>{{ data.item.paymentId }}</span>
                            </td>
                        </template>
                        <template #paymentDate="data">
                            <td class="text-center">
                                {{ data.item.paymentDate }}
                            </td>
                        </template>
                        <template #check_this="data">
                            <td class="py-2">
                                <CInputCheckbox
                                    :disabled="data.item.invoiceStatus == STATUS_PAID || data.item.invoiceStatus == STATUS_PROCESSING"
                                    :checked="selectedInvoices.indexOf(parseInt(data.item.invoiceNumber)) !== -1"
                                    @click.stop="return false"
                                    @change="invoiceClicked(data.item.invoiceNumber)"
                                />
                            </td>
                        </template>
                        <template #total="data">
                            <td class="text-right">
                                {{ data.item.total | currency }}
                            </td>
                        </template>
                        <template #check_this-header>
                            <CInputCheckbox
                                :checked="selectedInvoices.length == items.length"
                                @change="selectAllClicked($event)"
                            />
                        </template>
                    </CDataTable>

                    <DataTablePagination
                        :activePage="activePage"
                        :total="items && items.length || 0"
                        :limit="pageLimit"
                        @page-changed="pageChanged"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
/*
 * InvoiceList Vue.js view module for the invoices list for Suncast
 * Display the invoices List for all orders
 * @module InvoiceList
 * @author Mithun Paulose (Fresche Solutions)
 * @date June 2020
 */
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";    // Two-way mapping of local state fields to vuex
import Datepicker from "vuejs-datepicker";
import JsonCSV from "vue-json-csv";
import { authService } from "../../../../services/authService";
import DataTablePagination from "../components/DataTablePagination";

export default {
    name: "InvoiceList",
    components: {
        downloadCsv: JsonCSV,
        Datepicker,
        DataTablePagination,
    },
    created: function() {
        this.init();
    },
    data() {
        return {
            STATUS_PAID: 'Paid',
            STATUS_PROCESSING: 'Processing',
            dateFormat: "yyyy-MM-dd",
            limitReached: false,
            limit: null,
            pageLimit: 10,
            items: [],
            activePage: 1,
            collapseDuration: 0,
            hasPaymentHistoryPermission: false,
            fields: [
                {
                    key: "check_this",
                    label: "",
                    _style: "width:1%",
                    sorter: false,
                    filter: false
                },
                {
                    key: "invoiceNumber",
                    label: "Invoice Number",
                    _style: "text-align: center"
                },
                {
                    key: "invoiceDate",
                    label: "Invoice Date",
                    _style: "text-align: center"
                },
                {
                    key: "dueDate",
                    label: "Due Date",
                    _style: "text-align: center"
                },
                {
                    key: "invoiceStatus",
                    label: "Status",
                    _style: "text-align: center"
                },
                {
                    key: "paymentId",
                    label: "Payment Id",
                    _style: "text-align: center"
                },
                 {
                    key: "paymentDate",
                    label: "Payment Date",
                    _style: "text-align: center"
                },
                {
                    key: "total",
                    label: "Total",
                    _style: "text-align: right"
                }
            ]
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                if (route.query && route.query.page) {
                    this.activePage = Number(route.query.page);
                }
            }
        },
        // All/Open invoices toggle
        openInvoicesOnly: {
            immediate: true,
            handler(openOnly) {

                // Do a full fetch in case the dates have been changed before the selecting
                this.getInvoicesList(true);
            }
        },
    },
    computed: {
        ...mapFields("Invoice", ["invoices", "totals", "selectedInvoices", "fromDate", "toDate", "openInvoicesOnly"]),
        ...authService,
    },
    mounted() {
        this.pageLimit = this.getPageLimit();
    },
    methods: {
        ...mapMutations("Invoice", ["setFromDate", "setToDate", "setPageLimit", "setOpenInvociesOnly"]),
        ...mapGetters("Invoice", ["getSelectedInvoices", "getInvoiceList", "getInvoices", "getPageLimit", "getOpenInvoices"]),
        ...mapActions("Invoice", ["fetchInvoiceList", "updateSelectedInvoices", "clearTotals", "fetchOpenInvoiceList"]),
        ...mapGetters("User", ["getSelectedCustomer"]),
        async init() {

            // Update the redirect from route, if provided
            if (this.$route.params.redirect) {
                this.redirectTo = this.$route.params.redirect;
            }

            this.clearTotals();

            // Fetch Open Invoices. This will calculate and set the totals.
            await this.fetchOpenInvoiceList();

            // Get previously selected invoices from the store & ensure they're numeric
            this.selectedInvoices = this.getSelectedInvoices();
            this.selectedInvoices = this.selectedInvoices.map(Number);

            // Get the invoices list
            this.getInvoicesList(false);

            // Determine relevant user permissions
            this.hasPaymentHistoryPermission = authService.userAuthResourcePriv('Payment', 'all');
        },

        async getInvoicesList(fetchNew) {

            if(this.fromDate){
                this.fromDate.setHours(0);
                this.fromDate.setMinutes(0);
                this.fromDate.setSeconds(0);
            }

            if(this.toDate){
                this.toDate.setHours(12);
                this.toDate.setMinutes(59);
                this.toDate.setSeconds(59);
            }

            // open invoices only
            if (this.openInvoicesOnly) {
                this.items = [];
                let openInvoices = this.getOpenInvoices();

                // filter open invoices client side, by to from date
                if (openInvoices) {
                    for (let invoice of openInvoices.invoices) {
                        let invoiceDate = new Date(invoice.invoiceDate + ' 00:00'); // must add 00:00 or the date shows as one day before
                        if ((this.fromDate == null || invoiceDate >= this.fromDate) && (this.toDate == null || invoiceDate <= this.toDate)){
                            this.items.push(invoice);
                        }
                    }

                    this.limitReached = openInvoices.limitReached;
                    this.limit = openInvoices.limit;
                }
            }
            // full invoice list
            else{

                // No end date set - set default end date filter to today & save to the store
                if (this.toDate == null) {
                    let toDate = new Date();
                    this.setToDate(toDate);
                }

                // No from date set - set default from date filter to 1 month back from end date & save to the store
                if (this.fromDate == null) {
                    let fromDate = new Date();
                    fromDate.setYear(this.toDate.getFullYear());
                    fromDate.setMonth(this.toDate.getMonth() - 1);
                    fromDate.setDate(this.toDate.getDate());
                    this.setFromDate(fromDate);
                }

                let invoiceList = this.getInvoiceList();

                // Only fetch invoices on filter
                if (
                    fetchNew || // filtering
                    invoiceList == null || // have no invoices
                    invoiceList.invoices.length == 0 || // invoices are empty
                    invoiceList.customerId !== this.getSelectedCustomer().customerId // invoices are for a different customer
                ) {
                    // Get the invoice list for the date range in the store
                    await this.fetchInvoiceList({
                        fromDate: this.fromDate,
                        toDate: this.toDate
                    });
                    invoiceList = this.getInvoiceList();
                }

                // If there are no invoices
                if (invoiceList.invoices.length == 0) {
                    this.$toast.open({
                        message: "No Invoices found",
                        type: "error"
                    });
                }

                this.items = invoiceList.invoices;
                this.limitReached = invoiceList.limitReached;
                this.limit = invoiceList.limit;
            }
        },

        resetFilters() {
            this.setToDate(null);
            this.setFromDate(null);
            this.openInvoicesOnly = true;
        },

        getBadge(status) {
            switch (status) {
                case "Paid":
                    return "success";
                case "Open":
                    return "info";
                case "Processing":
                    return "warning";
                default:
                    "secondary";
            }
        },

        invoiceClicked(invoiceNumber) {

            invoiceNumber = parseInt(invoiceNumber);

            // check whether or not this is already selected
            let pos = this.selectedInvoices.indexOf(invoiceNumber);

            // insert if new invoice Number
            if (pos == -1) {
                this.selectedInvoices.push(invoiceNumber);
            }
            // delete if already existing -- means the user unclicked it.. not clean way to do this. should pass event and look if 'target.checked'
            else {
                this.selectedInvoices.splice(pos, 1);
            }
        },

        selectAllClicked(event) {
            if (event.target.checked) {
                this.items.map(invoice => {
                    invoice.invoiceNumber = parseInt(invoice.invoiceNumber);
                    let pos = this.selectedInvoices.indexOf(invoice.invoiceNumber);
                    if (pos == -1) {
                        this.selectedInvoices.push(invoice.invoiceNumber);
                    }
                });
            }
            else {
                this.selectedInvoices = [];
            }
        },

        // Navigate to pay invoices
        async payInvoices(invoices) {
            await this.updateSelectedInvoices(invoices);
            this.$router.push({ path: "/invoices/payInvoices" });
        },

        // Row clicked - go to its details page
        rowClicked(invoice) {
            this.$router.push({ path: `/invoices/display/${invoice.invoiceNumber}` });
        },

        // Change & save the page limit
        paginationChanged(pageLimit) {
            this.setPageLimit(pageLimit);
            this.pageLimit = pageLimit;
        },

        // Data table page change
        pageChanged(newPage) {

            // Get the page we're currently on
            let query = this.$router.currentRoute.query;

            // If it's different, navigate & set the active page
            if (!query.page || query.page != newPage) {
                this.activePage = newPage;
                this.$router.push({ query: { page: newPage } });
            }
        },
        // Go to payment detail page
        goToPayment(invoice) {
            this.$router.push({ path: `/payments/display/${invoice.paymentId}/${invoice.paymentDate}` });
        },
    }
};
</script>
<style>
.custom-control{
    display: inline-block;
}

.vdp-datepicker__clear-button{
    position: absolute;
    top: 6px;
    right: 10px;
}

</style>
